import { appendErrors as r } from "react-hook-form";
import { validateFieldsNatively as e, toNestError as o } from "@hookform/resolvers";
var n = function (e, o) {
    for (var n = {}; e.length;) {
      var s = e[0],
        t = s.code,
        i = s.message,
        a = s.path.join(".");
      if (!n[a]) if ("unionErrors" in s) {
        var u = s.unionErrors[0].errors[0];
        n[a] = {
          message: u.message,
          type: u.code
        };
      } else n[a] = {
        message: i,
        type: t
      };
      if ("unionErrors" in s && s.unionErrors.forEach(function (r) {
        return r.errors.forEach(function (r) {
          return e.push(r);
        });
      }), o) {
        var c = n[a].types,
          f = c && c[s.code];
        n[a] = r(a, o, n, t, f ? [].concat(f, s.message) : s.message);
      }
      e.shift();
    }
    return n;
  },
  s = function (r, s, t) {
    return void 0 === t && (t = {}), function (i, a, u) {
      try {
        return Promise.resolve(function (o, n) {
          try {
            var a = Promise.resolve(r["sync" === t.mode ? "parse" : "parseAsync"](i, s)).then(function (r) {
              return u.shouldUseNativeValidation && e({}, u), {
                errors: {},
                values: t.rawValues ? i : r
              };
            });
          } catch (r) {
            return n(r);
          }
          return a && a.then ? a.then(void 0, n) : a;
        }(0, function (r) {
          return {
            values: {},
            errors: r.isEmpty ? {} : o(n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
          };
        }));
      } catch (r) {
        return Promise.reject(r);
      }
    };
  };
export { s as zodResolver };